import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const OnlineMarketsTabsHeaderItem = ({ isSelectedTab, orderNotification, tabName, handleClickTab, index }) => {
    const [glow, setGlow] = useState(false);

    useEffect(() => {
        if (orderNotification) {
            setGlow(true);
            const timer = setTimeout(() => setGlow(false), 1000 * 30);
            return () => clearInterval(timer);
        }
    }, [orderNotification]);

    const onTabClick = () => handleClickTab(index);

    const activeTab = isSelectedTab ? 'TabActive' : 'TabInactive';

    return (
        <div className={`OnlineMarketsHeaderItem ${activeTab} ${glow ? 'glow' : ''}-${activeTab}`} onClick={onTabClick}>
            {tabName}
        </div>
    );
};

OnlineMarketsTabsHeaderItem.propTypes = {
    handleClickTab: PropTypes.func.isRequired,
    isSelectedTab: PropTypes.bool.isRequired,
    tabName: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    orderNotification: PropTypes.shape({}),
};
OnlineMarketsTabsHeaderItem.defaultProps = {
    orderNotification: null,
};

export default OnlineMarketsTabsHeaderItem;



// WEBPACK FOOTER //
// ./source/components/OnlineMarketsTabsHeaderItem.js